// load static clustering data from json file

export const loadClusteringData = async () => {
  try {
    const response = await fetch('/clustering_data.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('failed to load clustering data:', error);
    return {};
  }
};
